export const GET_CENSUS_REQUEST = 'GET_CENSUS_REQUEST';
export const GET_CENSUS_REQUEST_SUCCESS = 'GET_CENSUS_REQUEST_SUCCESS';
export const GET_CENSUS_REQUEST_FAILURE = 'GET_CENSUS_REQUEST_FAILURE';
export const CLEAR_CENSUS_PARAMS = 'CLEAR_CENSUS_PARAMS';
